import { useContext } from "react";

import { TourContext } from "./TourContext";

export const useTourContext = () => {
  const context = useContext(TourContext);

  if (!context) {
    throw new Error("useTourContext must be used within a TourProvider");
  }

  return context;
};
